import { LatLng } from "./latlng";
import { AddressType } from "../services/account/settings.service";

export class Address {
    AddressType: AddressType;
    Description: string;
    Location: LatLng;
    BoundingBox: number[];

    constructor(addressType: AddressType, description: string, location: LatLng, boundingBox: number[]) {
        this.AddressType = addressType;
        this.Description = description;
        this.Location = location;
        this.BoundingBox = boundingBox;
    }
}
